<div ngbDropdown
     [placement]="'bottom-right'"
     class="dropdown-toggle-none"
     role="group">
  <button class="btn text-start text-overflow px-0 lh-1 {{toggleExtraClasses}}" ngbDropdownToggle>
    <ng-content></ng-content>
  </button>
  <div class="dropdown-menu py-0" ngbDropdownMenu>
    <a class="dropdown-item px-3 py-2 font-md"
       [routerLink]="['/', 'profile', profileMainPage]"
       [translate]="'profile.menu.myAccount'">My account
    </a>
    <button class="dropdown-item px-3 py-2 font-md"
            (click)="logout()"
            [translate]="'profile.menu.logout'">Log out
    </button>
  </div>
</div>
